module.exports = __webpack_public_path__ + "static/media/6_square.d168cd06.png";